import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay, requireAuth } from '@/test/mocks/utils';

import { SelectVariantResponse } from '../types';

import { mockProfileState } from './get-profiles';

export const selectVariant = (
  variant_id: string
): Promise<SelectVariantResponse.Root> => {
  return axios.post(`/user/v1/select-variant?variant_id=${variant_id}`);
};

export const selectVariantMockHandler = http.post(
  `${env.API_URL}/user/v1/select-variant`,
  async ({
    request,
    cookies,
  }): Promise<HttpResponse<SelectVariantResponse.Root>> => {
    await networkDelay();
    const { error } = requireAuth(cookies);
    if (error) {
      return HttpResponse.json(
        {
          message: error,
          status: 'Failure',
          'selected-variant-id': '',
        },
        { status: 401 }
      );
    }

    // Parse the variant_id from query parameters
    const url = new URL(request.url);
    const variantId = url.searchParams.get('variant_id');

    // Validate that variant_id exists
    if (!variantId) {
      return HttpResponse.json(
        {
          message: 'Variant ID is required',
          status: 'Failure',
          'selected-variant-id': '',
        },
        { status: 400 }
      );
    }

    // Update the selected variant in the mock state
    mockProfileState.setSelectedVariant(variantId);

    return HttpResponse.json({
      status: 'Success',
      message: 'Variant selected successfully',
      'selected-variant-id': variantId,
    });
  }
);
